import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../../services/modal-dialogs';
import { SelectItem } from 'primeng/primeng';
import { AssetStatisticsRequest } from '../../../../models/ss-api/requests/asset.statistics.request';
import { ItemCategoryTypes } from '../../../../models/domain/item.category.type';
import { AssetStatisticsItemArray } from '../../../../models/ss-api/responses/asset.statistics.item';
import { ssApiService } from '../../../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

import * as moment from 'moment';
import { StatsUsageHistoryChartDialog } from '../../../../dialogs/stats.usage.history.chart/stats.usage.history.chart.dialog';

@Component({
    selector: 'object-stats',
    templateUrl: './object.stats.component.html',
    styleUrls: ['./object.stats.component.css']
})
export class ObjectStatsComponent implements OnInit {

    statisticsResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    // VARIABLES
    IsBusy: boolean = false;

    Keyword: string;
    StartDate: Date;
    EndDate: Date;

    Categories: Array<ItemCategoryTypes> = new Array<ItemCategoryTypes>();
    CategoryOptions: SelectItem[] = [
        { label: 'Assets', value: 10 },
        { label: 'Plants & Trees', value: 20 }
    ];

    Statistics: AssetStatisticsItemArray = new AssetStatisticsItemArray();

    StatisticsFilter: string;

    constructor(private dialogService: DialogService, private api: ssApiService, private sweetAlert: SweetAlertService) { }

    ngOnInit() {
        this.StartDate = moment().subtract(30, 'days').toDate();
        this.EndDate = new Date();
    }

    ConcatLabel(label: string) {
        let regex = new RegExp(/([^\\]+$)/gm);
        let name = label.match(regex).splice(0, 1);

        return name;
    }

    LoadStats() {
        this.IsBusy = true;

        this.firstResult = 0;
        this.lastResult = 24;

        let request = new AssetStatisticsRequest();
        request.StartDate = this.StartDate;
        request.EndDate = this.EndDate;
        request.ItemCategoryTypes = this.Categories;
        request.Keyword = this.Keyword;
        request.MaxItemCount = 5000;

        if (request.StartDate == null || request.StartDate == undefined) {
            this.sweetAlert.swal({
                type: 'error',
                title: 'No Start Date',
                text: 'Please select a start date to begin searching'
            }).then(() => { }, () => { });
            this.IsBusy = false;
            return false;
        }

        if (request.EndDate == null || request.EndDate == undefined) {
            this.sweetAlert.swal({
                type: 'error',
                title: 'No End Date',
                text: 'Please select a end date to begin searching'
            }).then(() => { }, () => { });
            this.IsBusy = false;
            return false;
        }

        let subscription = this.api.AssetStatistics(request).subscribe(result => {

            subscription.unsubscribe();

            this.Statistics = result.Data;
            this.IsBusy = false;
        });
    }

    showUsageChartDialog(newItemName: string = 'Placeholder Name') {

        let disposable = this.dialogService.addDialog(StatsUsageHistoryChartDialog, {
            itemName: newItemName,
            message: 'Confirm message'
        }).subscribe(result => {
            disposable.unsubscribe();
        });
    }

    CanSearch() {
        if (!this.StartDate || !this.EndDate || this.Categories.length < 1)
            return false;

        return true;
    }

    paginateStatistics(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

}
